import { inject, injectable, injectFromBase } from 'inversify'
import type { RouteLocationNormalized, Router } from 'vue-router'
import ExternalTrackerService from '@/services/tracking/externalTrackerService'
// eslint-disable-next-line tp/forbid-import-composable-to-service,tp/using-vue-in-services-restriction
import type { Plugin } from '@/composition/vue/compositionApi'
import type { ExternalTrackerAsPlugin, TrackableConfig } from '@/services/tracking/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type RouterService from '@/services/route/routerService'
import { ROUTER_AFTER_EACH } from '@/services/route/types'
import type SubscriptionService from '@/services/transport/subscriptionService'
import { gettingStartedRoutName } from '@/routes/user/getting-started/types'
import type LocalStorageAdapter from '@/services/transport/storage/localStorageAdapter'

@injectable()
@injectFromBase()
export class GartnerConversionService extends ExternalTrackerService {
  constructor(
    @inject(SERVICE_TYPES.RouterService) protected readonly routerService: RouterService,
    @inject(SERVICE_TYPES.SubscriptionService) protected readonly subscriptionService: SubscriptionService,
    @inject(SERVICE_TYPES.LocalStorageAdapter) protected readonly localStorageAdapter: LocalStorageAdapter,
  ) {
    super()
  }

  private localStorageGettingStartedKey = 'tm::isGettingStartedVisited'

  public getConfig(): TrackableConfig {
    // no credentials required
    return {
      id: '',
    }
  }

  public getPlugin(): Plugin {
    return {
      install: () => this.initialize(),
    } satisfies Plugin
  }

  protected async initialize(): Promise<void> {
    const router: Router = this.routerService.getRouter()
    const subscriptionKey = 'gartnerAnalytics'
    /* eslint-disable */
    const track = (to?: RouteLocationNormalized) => {
      // @ts-expect-error gartner initial script from docs
      if (window._gz) {
        // @ts-expect-error gartner initial script from docs
        window._gz('2dfb2552-3dcf-4721-a5f9-aead9602994d', 'c8dbc4d64e13c51adf4b94f9bc03408e')
      }
      this.trackGettingStartedEvent(to)
    }
    const initGartner = () => {
      ;(function (l, o, w, n, g) {
        // @ts-expect-error gartner initial script from docs
        window._gz = function (e, t) {
          // @ts-expect-error gartner initial script from docs
          window._ct = { vid: e, vkey: t, uc: true, hasDoNotTrackIPs: false }
          // @ts-expect-error gartner initial script from docs
          window.ct
        }
        // @ts-expect-error gartner initial script from docs
        n = l.createElement(o)
        // @ts-expect-error gartner initial script from docs
        g = l.getElementsByTagName(o)[0]
        // @ts-expect-error gartner initial script from docs
        n['async'] = 1
        // @ts-expect-error gartner initial script from docs
        n.src = w
        // @ts-expect-error gartner initial script from docs
        g.parentNode.insertBefore(n, g)
      })(document, 'script', 'https://tr.capterra.com/static/wp.js')
      track()
    }
    /* eslint-enable */
    const trackingHandler = async () => {
      initGartner()
      await router.isReady()
      if (!this.subscriptionService.exist(subscriptionKey)) {
        this.subscriptionService.subscribeWithSubscriptionKey(ROUTER_AFTER_EACH, track, subscriptionKey, true)
      }
    }
    const trackerAsPlugin: ExternalTrackerAsPlugin = {
      trackingHandler,
      loadOnCustomEvent: true,
    }
    this.initializeTrackerAsPlugin(trackerAsPlugin)
  }

  protected shouldTrackGettingStartedEvent(to?: RouteLocationNormalized) {
    if (!to || to.name !== gettingStartedRoutName) {
      return false
    }
    return !this.localStorageAdapter.get(this.localStorageGettingStartedKey)
  }

  protected trackGettingStartedEvent(to?: RouteLocationNormalized) {
    if (!this.shouldTrackGettingStartedEvent(to)) {
      return
    }
    // @ts-expect-error gartner initial script from docs
    if (window.ct?.sendEvent) {
      // @ts-expect-error gartner initial script from docs
      window.ct.sendEvent({ installationId: 'f7b72ae5-47ab-40ea-a09f-97964e3087d1' })
      this.localStorageAdapter.set(this.localStorageGettingStartedKey, 'true')
    }
  }
}
